// 子午线埋点js兼容处理
// 全局变量
const joyaGlobalKeys = ['jaq', 'JA', 'privateLogJOYAJS', 'log', 'logJSON', 'expLogJSON', 'nlog', 'isMeta'];
function JoyaGlobalDefinition(code, url) {
  if (/\/\/wl\.jd\.com\/joya\.js/.test(url)) {
    return joyaGlobalKeys.reduce((prev, cur) => {
      return prev + `typeof ${cur} !== "undefined" && (window.${cur} = ${cur});`;
    }, code + ';');
  }
  return code;
}
var painfulJoya = {
  scopeProperties: joyaGlobalKeys,
  loader: JoyaGlobalDefinition,
};

export default painfulJoya;
